import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type InternationalMarketsFlatTeamSettingGroupId =
  "international_markets.markets";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason: "International shipping settings including customs and markets.",
};

export const InternationalMarketsFlatTeamSettingGroups = [
  {
    id: "international_markets.markets",
    title: "Markets",
    description: "Markets settings on the International markets page.",
    productArea: "fulfillment",
    access: directMerchantAccess(
      SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "international/markets" },
    synonyms: ["markets", "international markets"],
  },
] as const satisfies readonly SettingGroupDefinition<InternationalMarketsFlatTeamSettingGroupId>[];

type _assertAllInternationalMarketsFlatTeamSettingGroupIdsProvided =
  InternationalMarketsFlatTeamSettingGroupId extends (typeof InternationalMarketsFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allInternationalMarketsFlatTeamSettingGroupIdsProvided: _assertAllInternationalMarketsFlatTeamSettingGroupIdsProvided = true;
void _allInternationalMarketsFlatTeamSettingGroupIdsProvided;

export const InternationalMarketsFlatTeamSettingGroupById: Record<
  InternationalMarketsFlatTeamSettingGroupId,
  SettingGroupDefinition<InternationalMarketsFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      InternationalMarketsFlatTeamSettingGroupId,
      SettingGroupDefinition<InternationalMarketsFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of InternationalMarketsFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    InternationalMarketsFlatTeamSettingGroupId,
    SettingGroupDefinition<InternationalMarketsFlatTeamSettingGroupId>
  >;
})();
